const staff = [
  { name: 'Paul', image: './images/Paul.jpg', role: 'Dentist, Owner' },
  { name: 'Meadow', image: './images/Meadow.jpeg', role: 'Dental Assistant' },
  { name: 'Sue', image: './images/Sue.jpeg', role: 'Hygienist' },
  { name: 'Ingrid', image: './images/Ingrid.jpg', role: 'Hygienist' },
  { name: 'Ana', image: './images/Ana.jpeg', role: 'Office Manager' },
  { name: 'Anita', image: './images/Anita.jpg', role: 'Managing Partner' },
];

export default staff;
